import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  IconButton,
  Input,
  Button,
  FormLabel,
  SimpleGrid,
  GridItem,
  Select,
  useToast,
} from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const EditTrsList = ({ teacher, allocation_id, RefreshData }) => {
  const { id } = useParams(); // Bus route ID
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState({
    name: "",
    pickup: "",
    drop: "",
    startDate: "",
    endDate: "",
    busFee: "",
    fine: "",
    dueDate: "",
    trip: "",
  });
  const [busStops, setBusStops] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const toast = useToast();

  // Fetch bus stops
  useEffect(() => {
    const fetchBusStops = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/bus/bus_route/list_stop_names.php?bus_route_id=${id}`
        );
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          setBusStops(data.data);
        } else {
          console.error("Failed to fetch bus stops:", data.message);
        }
      } catch (error) {
        console.error("Error fetching bus stops:", error);
      }
    };
    fetchBusStops();
  }, [id]);

  // Fetch teacher data
  useEffect(() => {
    const fetchTeacherData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${BASE_URL}/admin/bus/teachers/view_bus_teachers.php?allocation_id=${allocation_id}&teacher_id=${teacher}`
        );
        const data = await response.json();
        console.log("view_tr_allocation", data);

        if (data.success && data.data) {
          const teacherData = data.data;
          setSelectedTeacher({
            name: teacherData.name || "",
            pickup: teacherData.pickup_location_id || "",
            drop: teacherData.drop_location_id || "",
            startDate: teacherData.start_date || "",
            endDate: teacherData.end_date || "",
            busFee: teacherData.bus_fee || "",
            fine: teacherData.fine || "",
            dueDate: teacherData.due_date || "",
            trip: teacherData.trip || "",
          });
        } else {
          console.error("Failed to fetch teacher data:", data.message);
          setError("Failed to fetch teacher data.");
        }
      } catch (error) {
        console.error("Error fetching teacher data:", error);
        setError("An error occurred while fetching teacher data.");
      } finally {
        setLoading(false);
      }
    };

    if (allocation_id && teacher) {
      fetchTeacherData();
    }
  }, [allocation_id, teacher]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setError(null);
  };

  const handleInputChange = (e, field) => {
    setSelectedTeacher({ ...selectedTeacher, [field]: e.target.value });
  };

  const saveTeacherData = async () => {
    const payload = {
      user_id: sessionStorage.getItem("user_id"),
      school_id: sessionStorage.getItem("school_id"),
      allocation_id: allocation_id,
      pickup_location: selectedTeacher.pickup || null,
      drop_location: selectedTeacher.drop || null,
      bus_fee: selectedTeacher.busFee,
      due_date: selectedTeacher.dueDate || null,
      start_date: selectedTeacher.startDate || null,
      end_date: selectedTeacher.endDate || null,
      trip: selectedTeacher.trip || null,
      teacher_id: teacher,
    };
    console.log("data edit", payload);

    try {
      const response = await fetch(
          `${BASE_URL}/admin/bus/teachers/edit_teachers.php`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      console.log("edit tr alocation", response);

      const result = await response.json();
      console.log("res", result);

      if (result.success) {
        toast({
          title: "Success",
          description: "Teacher details updated successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        closeModal();
        RefreshData();
      } else {
        toast({
          title: "Error",
          description: result.message || "Failed to update teacher details.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "An error occurred while saving teacher details.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <div>
      <IconButton
        aria-label="Edit teacher"
        icon={<FaEdit />}
        size="sm"
        colorScheme="blue"
        onClick={openModal}
      />

      <Modal isOpen={isModalOpen} onClose={closeModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Teacher Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading && <p>Loading teacher data...</p>}
            {error && <p>{error}</p>}
            {!loading && !error && (
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
                <GridItem>
                  <FormLabel>Teacher Name</FormLabel>
                  <Input
                    placeholder="Enter teacher name"
                    value={selectedTeacher.name}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Pickup Point</FormLabel>
                  <Select
                    placeholder="Select Pick-Up"
                    value={selectedTeacher.pickup}
                    onChange={(e) => handleInputChange(e, "pickup")}
                  >
                    {busStops.map((stop) => (
                      <option key={stop.id} value={stop.id}>
                        {stop.stop_name}
                      </option>
                    ))}
                  </Select>
                </GridItem>
                <GridItem>
                  <FormLabel>Drop Point</FormLabel>
                  <Select
                    placeholder="Select Drop"
                    value={selectedTeacher.drop}
                    onChange={(e) => handleInputChange(e, "drop")}
                  >
                    {busStops.map((stop) => (
                      <option key={stop.id} value={stop.id}>
                        {stop.stop_name}
                      </option>
                    ))}
                  </Select>
                </GridItem>
                <GridItem>
                  <FormLabel>Start Date</FormLabel>
                  <Input
                    type="date"
                    value={selectedTeacher.startDate}
                    onChange={(e) => handleInputChange(e, "startDate")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>End Date</FormLabel>
                  <Input
                    type="date"
                    value={selectedTeacher.endDate}
                    onChange={(e) => handleInputChange(e, "endDate")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Due Date</FormLabel>
                  <Input
                    type="date"
                    value={selectedTeacher.dueDate}
                    onChange={(e) => handleInputChange(e, "dueDate")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Bus Fee</FormLabel>
                  <Input
                    placeholder="Enter bus fee"
                    value={selectedTeacher.busFee}
                    onChange={(e) => handleInputChange(e, "busFee")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Trip</FormLabel>
                  <Input
                    placeholder="Enter trip details"
                    value={selectedTeacher.trip}
                    onChange={(e) => handleInputChange(e, "trip")}
                  />
                </GridItem>
              </SimpleGrid>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" mr={3} onClick={saveTeacherData}>
              Save
            </Button>
            <Button variant="outline" onClick={closeModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default EditTrsList;
